import { Injectable } from '@angular/core';

import { HttpNewService } from './http-new.service';
import { IResponseGetLpuInfo } from '../../interfaces/lpu.interfaces';
import { IAppConfig } from '../../interfaces/response.interfaces';
import { Store } from '../../services/store.service';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable()
export class LoadService {
    private _appConfigData: IAppConfig | null = null;
    private _LpuData: IResponseGetLpuInfo | null = null;
    public configLoaded = false;

    public constructor(private httpNew: HttpNewService) {}

    public get LpuData(): IResponseGetLpuInfo | null {
        return this._LpuData;
    }

    public get configData(): IAppConfig | null {
        return this._appConfigData;
    }

    public cipher = (str: string) => {
        return str
            .split('')
            .map((char) => String.fromCharCode(char.charCodeAt(0) + 1))
            .join('');
    };

    public decipher = (str: string) => {
        return str
            .split('')
            .map((char) => String.fromCharCode(char.charCodeAt(0) - 1))
            .join('');
    };

    public setAccessUserConfig(value: string[]) {
        const encodedValue = this.cipher(JSON.stringify(value));
        Store.setStringData('accessConfigFields', encodedValue);
    }

    public get getAccessUserConfig(): string[] {
        const item = Store.getDataString('accessConfigFields');
        if (item) {
            const decodedValue = JSON.parse(this.decipher(item));
            // console.log(decodedValue);
            return decodedValue;
        } else {
            return [];
        }
    }

    // Загрузка конфиг файла на сервере
    public loadAppConfig(): Observable<IAppConfig | null> {
        return this.httpNew.get<IAppConfig>('/settings/app_config').pipe(
            tap((result) => {
                this._appConfigData = result;
                this.configLoaded = true;
            }),
            catchError((error) => {
                console.error('Failed to load app config', error);
                this.configLoaded = false;
                return of(null);
            }),
        );
    }

    public updateAppConfig(appConfig: IAppConfig): void {
        this._appConfigData = appConfig;
    }

    // Загрузка данных о мед учреждении
    public loadLpu(): Observable<IResponseGetLpuInfo | null> {
        return this.httpNew.get<IResponseGetLpuInfo>('/settings/lpuinfo').pipe(
            tap((result) => (this._LpuData = result)),
            catchError((error) => {
                console.error('Failed to load LPU info', error);
                return of(null);
            }),
        );
    }
}
